import React, { useEffect } from 'react'
import { connect, useDispatch } from 'react-redux'
import './App.css'
import ReactDependentScript from 'react-dependent-script'
import PropTypes from 'prop-types'
import { MuiThemeProvider } from '@material-ui/core/styles'
import theme from '../../theme/theme'
import AppRouter from '../../containers/AppRouter'
import checkTokenExpiration from '../../helpers/checkTokenExpiration'
import { signOut } from '../../actions/signIn'
import { syncFirmware } from '../../actions/firmware'

const App = ({ accessToken, tokenExpireTime }) => {
  const dispatch = useDispatch()

  useEffect(() => {
    window.scrollTo(0, 0)
    dispatch(syncFirmware())
    if (accessToken.length && checkTokenExpiration(tokenExpireTime)) {
      dispatch(signOut())
    }
  }, [accessToken.length, dispatch, tokenExpireTime])

  return (
    <ReactDependentScript
      scripts={[
        'https://maps.googleapis.com/maps/api/js?key=AIzaSyAX8HCt8teGLIgx7AWiJY3PDHifmHb7V_s&libraries=places',
      ]}
    >
      <MuiThemeProvider theme={theme}>
        <AppRouter>
          <div className="App" />
        </AppRouter>
      </MuiThemeProvider>
    </ReactDependentScript>
  )
}

const mapStateToProps = (state) => {
  const { accessToken, tokenExpireTime } = state.secrets
  return {
    accessToken,
    tokenExpireTime,
  }
}

App.propTypes = {
  accessToken: PropTypes.string.isRequired,
  tokenExpireTime: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
}

const enhance = connect(mapStateToProps)(App)

export default enhance
